import React from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { Button, ErrorDetail, Input } from '@/ui/components'
import { strings } from './Authentication.strings'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

interface FormData {
  email: string
  password: string
}

interface Props {
  signIn: (data: FormData) => void
  loading?: boolean
  error?: Error | null
}

export const SignInForm: React.FC<Props> = ({ signIn, loading, error }) => {
  const intl = useIntl()

  const {
    register,
    handleSubmit,
    // formState: { errors }, // TODO: Connect form errors
  } = useForm<FormData>()

  const onSubmission = handleSubmit((data) => {
    signIn(data)
  })

  return (
    <Form onSubmit={onSubmission}>
      <h2>
        <FormattedMessage {...strings.signInTitle} />
      </h2>
      <Input
        type="email"
        label={intl.formatMessage(strings.emailLabel)}
        placeholder={intl.formatMessage(strings.emailPlaceholder)}
        {...register('email')}
        autoComplete="username"
        required
        disabled={loading}
      />
      <Input
        type="password"
        label={intl.formatMessage(strings.passwordLabel)}
        placeholder={intl.formatMessage(strings.passwordPlaceholder)}
        {...register('password')}
        autoComplete="current-password"
        required
        disabled={loading}
      />
      {error ? <ErrorDetail error={'Error signing in'} /> : null}
      <Button>
        <FormattedMessage {...strings.signInBtn} />
      </Button>
    </Form>
  )
}
